import { BPSymbol } from '../types';
import {
  FIELD_MP as MP,
  FIELD_ID as FID,
  FIELD_Z0 as Z0,
  FIELD_HAS_EC as EC,
  LENGTH_STR_FIELD as LSF,
} from '../types/dimension';
import { TKItemProperty } from '../types/entity';

type CommonCell = {
  /** current field */
  field: string;
  /** if this column is sortable */
  sortable?: boolean;
};

export type HeaderCell = {
  name: string;
} & CommonCell;

export type SymbolCell = {
  /** symbol internal id */
  id: string;
  /** `input` if true, otherwise plain div will be built  */
  editable: boolean;
  value: string | number;
  /** title for hover */
  title?: string;
  /** value type: 'string' | 'bar' | 'image' | 'button' */
  type: string;
  /** if this symbol validated manually */
  confirmed?: boolean;
  /** all dimension fields in table, will attach to `completion` cell */
  fields?: string[];
  /** symbol type: like `ELBOW` */
  class: string;
  /** if available to edit, determine `disabled` attribute of input */
  invisible?: boolean;
  /**
   * allow to focus on tab change, false by default
   * @deprecated
   */
  focusable?: boolean;
  /** item property definition */
  itemProperty?: TKItemProperty | null;
  /** drawing unit */
  unit?: string;
} & CommonCell;

export type SymbolRow = SymbolCell[];
export type ROWS = { row: SymbolRow; symbol: BPSymbol }[];

/**
 * do two this:
 * - setup a basice order for dimension fields
 * - exclude some invisible fields
 * @param fields
 * @returns
 */
export const tableFieldsOrder = (fields: string[]) => {
  const hiddenFields = [EC];
  const showCheck = (f: string) => !hiddenFields.includes(f);
  return [...fields].sort().filter(showCheck);
};

/**
 * ! FINAL place to adjust fied order before display!
 * @date 2025/09/08
 *
 * Check length field to re-order the cell list.
 *
 * FIXME: Move `LSF` to the back if found
 * with the request of Simon
 * @date 2024/03/15
 *
 * another issue regarding `zone` field:
 * https://taksoai.atlassian.net/browse/TAK-918
 * @date 2025/10/23
 *
 * @param fields
 * @param cells
 */
export const putFieldToBack = (fields: string[], cells: CommonCell[]) => {
  const moveBack = (cells: CommonCell[], field: string) => {
    const targetFieldPos = cells.findIndex((sf) => sf.field == field);
    const [targetCell] = cells.splice(targetFieldPos, 1);
    cells.push(targetCell);
  };
  // ! add it as first tuning - 2025/10/23
  const hasZone = fields.includes(Z0);
  if (hasZone) {
    moveBack(cells, Z0);
  }
  const hasLSF = fields.includes(LSF);
  if (hasLSF) {
    moveBack(cells, LSF);
  }
  const hasIDF = fields.includes(FID);
  if (hasIDF) {
    moveBack(cells, FID);
  }
  const hasMPF = fields.includes(MP);
  if (hasMPF) {
    moveBack(cells, MP);
  }
};
